var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "page" },
    [
      _c(
        "el-form",
        {
          ref: "searchForm",
          staticClass: "query-form",
          attrs: { size: "small", inline: true, model: _vm.searchForm },
          nativeOn: {
            keyup: function ($event) {
              if (
                !$event.type.indexOf("key") &&
                _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
              ) {
                return null
              }
              return _vm.refreshList()
            },
            submit: function ($event) {
              $event.preventDefault()
            },
          },
        },
        [
          _c(
            "el-form-item",
            { attrs: { prop: "title" } },
            [
              _c("el-input", {
                attrs: { size: "small", placeholder: "标题", clearable: "" },
                model: {
                  value: _vm.searchForm.title,
                  callback: function ($$v) {
                    _vm.$set(_vm.searchForm, "title", $$v)
                  },
                  expression: "searchForm.title",
                },
              }),
            ],
            1
          ),
          _c(
            "el-form-item",
            [
              _c(
                "el-button",
                {
                  attrs: {
                    type: "primary",
                    size: "small",
                    icon: "el-icon-search",
                  },
                  on: {
                    click: function ($event) {
                      return _vm.refreshList()
                    },
                  },
                },
                [_vm._v("查询")]
              ),
              _c(
                "el-button",
                {
                  attrs: { size: "small", icon: "el-icon-refresh-right" },
                  on: {
                    click: function ($event) {
                      return _vm.resetSearch()
                    },
                  },
                },
                [_vm._v("重置")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "bg-white top" },
        [
          _c("vxe-toolbar", {
            attrs: {
              refresh: { query: _vm.refreshList },
              export: "",
              print: "",
              custom: "",
            },
            scopedSlots: _vm._u([
              {
                key: "buttons",
                fn: function () {
                  return [
                    _vm.hasPermission("notify:add")
                      ? _c(
                          "el-button",
                          {
                            attrs: {
                              type: "primary",
                              size: "small",
                              icon: "el-icon-plus",
                            },
                            on: {
                              click: function ($event) {
                                return _vm.add()
                              },
                            },
                          },
                          [_vm._v("新建")]
                        )
                      : _vm._e(),
                    _vm.hasPermission("notify:edit")
                      ? _c(
                          "el-button",
                          {
                            attrs: {
                              type: "warning",
                              size: "small",
                              icon: "el-icon-edit-outline",
                              disabled:
                                _vm.$refs.notifyTable &&
                                _vm.$refs.notifyTable.getCheckboxRecords()
                                  .length !== 1,
                              plain: "",
                            },
                            on: {
                              click: function ($event) {
                                return _vm.edit()
                              },
                            },
                          },
                          [_vm._v("修改")]
                        )
                      : _vm._e(),
                    _vm.hasPermission("notify:del")
                      ? _c(
                          "el-button",
                          {
                            attrs: {
                              type: "danger",
                              size: "small",
                              icon: "el-icon-delete",
                              disabled:
                                _vm.$refs.notifyTable &&
                                _vm.$refs.notifyTable.getCheckboxRecords()
                                  .length === 0,
                              plain: "",
                            },
                            on: {
                              click: function ($event) {
                                return _vm.del()
                              },
                            },
                          },
                          [_vm._v("删除")]
                        )
                      : _vm._e(),
                  ]
                },
                proxy: true,
              },
            ]),
          }),
          _c(
            "div",
            { staticStyle: { height: "calc(100% - 80px)" } },
            [
              _c(
                "vxe-table",
                {
                  ref: "notifyTable",
                  attrs: {
                    border: "inner",
                    "auto-resize": "",
                    resizable: "",
                    height: "auto",
                    loading: _vm.loading,
                    size: "small",
                    "show-header-overflow": "",
                    "show-overflow": "",
                    "highlight-hover-row": "",
                    "menu-config": {},
                    "print-config": {},
                    "import-config": {},
                    "export-config": {},
                    "sort-config": { remote: true },
                    data: _vm.dataList,
                    "checkbox-config": {},
                  },
                  on: { "sort-change": _vm.sortChangeHandle },
                },
                [
                  _c("vxe-column", { attrs: { type: "seq", width: "40" } }),
                  _c("vxe-column", {
                    attrs: { type: "checkbox", width: "40px" },
                  }),
                  _c("vxe-column", {
                    attrs: { title: "标题", field: "title", sortable: "" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _vm.hasPermission("notify:edit") &&
                            scope.row.status === "0"
                              ? _c(
                                  "el-link",
                                  {
                                    attrs: {
                                      type: "primary",
                                      underline: false,
                                    },
                                    on: {
                                      click: function ($event) {
                                        return _vm.edit(scope.row.id)
                                      },
                                    },
                                  },
                                  [_vm._v(_vm._s(scope.row.title))]
                                )
                              : _vm.hasPermission("notify:view")
                              ? _c(
                                  "el-link",
                                  {
                                    attrs: {
                                      type: "primary",
                                      underline: false,
                                    },
                                    on: {
                                      click: function ($event) {
                                        return _vm.view(scope.row.id)
                                      },
                                    },
                                  },
                                  [_vm._v(_vm._s(scope.row.title))]
                                )
                              : _c("span", [_vm._v(_vm._s(scope.row.title))]),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("vxe-column", {
                    attrs: { title: "类型", field: "type", sortable: "" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.$dictUtils.getDictLabel(
                                    "oa_notify_type",
                                    scope.row.type,
                                    "-"
                                  )
                                ) +
                                " "
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("vxe-column", {
                    attrs: { title: "内容", field: "content", sortable: "" },
                  }),
                  _c("vxe-column", {
                    attrs: { title: "附件", field: "files", sortable: "" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return _vm._l(
                            (scope.row.files || "").split(","),
                            function (item, index) {
                              return _c(
                                "el-link",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: scope.row.files,
                                      expression: "scope.row.files",
                                    },
                                  ],
                                  key: index,
                                  staticStyle: { "margin-right": "8px" },
                                  attrs: { href: item, target: "_blank" },
                                },
                                [
                                  _c("el-tag", [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          decodeURIComponent(
                                            item.substring(
                                              item.lastIndexOf("&name=") + 6
                                            )
                                          )
                                        )
                                    ),
                                  ]),
                                ],
                                1
                              )
                            }
                          )
                        },
                      },
                    ]),
                  }),
                  _c("vxe-column", {
                    attrs: { title: "状态", field: "status", sortable: "" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            scope.row.status === "1"
                              ? _c("el-tag", { attrs: { type: "success" } }, [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.$dictUtils.getDictLabel(
                                          "oa_notify_status",
                                          scope.row.status,
                                          "-"
                                        )
                                      )
                                  ),
                                ])
                              : _vm._e(),
                            scope.row.status === "0"
                              ? _c("el-tag", { attrs: { type: "danger" } }, [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.$dictUtils.getDictLabel(
                                          "oa_notify_status",
                                          scope.row.status,
                                          "-"
                                        )
                                      )
                                  ),
                                ])
                              : _vm._e(),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("vxe-column", {
                    attrs: { title: "查阅状态", field: "status", sortable: "" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _vm._v(
                              " " +
                                _vm._s(
                                  scope.row.readNum +
                                    "/" +
                                    (parseInt(scope.row.readNum) +
                                      parseInt(scope.row.unReadNum))
                                ) +
                                " "
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("vxe-column", {
                    attrs: {
                      title: "发布者",
                      field: "createBy.name",
                      sortable: "",
                    },
                  }),
                  _c("vxe-column", {
                    attrs: {
                      title: "操作",
                      width: "200px",
                      fixed: "right",
                      align: "center",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _vm.hasPermission("notify:view")
                              ? _c(
                                  "el-button",
                                  {
                                    attrs: {
                                      type: "text",
                                      icon: "el-icon-view",
                                      size: "small",
                                    },
                                    on: {
                                      click: function ($event) {
                                        return _vm.view(scope.row.id)
                                      },
                                    },
                                  },
                                  [_vm._v("查看")]
                                )
                              : _vm._e(),
                            _c(
                              "el-dropdown",
                              {
                                staticStyle: { "margin-left": "10px" },
                                attrs: { size: "small" },
                              },
                              [
                                _c(
                                  "el-button",
                                  { attrs: { type: "text", size: "small" } },
                                  [
                                    _vm._v(" 更多"),
                                    _c("i", {
                                      staticClass:
                                        "el-icon-arrow-down el-icon--right",
                                    }),
                                  ]
                                ),
                                _c(
                                  "el-dropdown-menu",
                                  {
                                    attrs: { slot: "dropdown" },
                                    slot: "dropdown",
                                  },
                                  [
                                    _vm.hasPermission("notify:edit") &&
                                    scope.row.status === "0"
                                      ? _c(
                                          "el-dropdown-item",
                                          [
                                            _c(
                                              "el-button",
                                              {
                                                attrs: {
                                                  type: "text",
                                                  icon: "el-icon-edit",
                                                  size: "small",
                                                },
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.edit(
                                                      scope.row.id
                                                    )
                                                  },
                                                },
                                              },
                                              [_vm._v("修改")]
                                            ),
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                    _vm.hasPermission("notify:del")
                                      ? _c(
                                          "el-dropdown-item",
                                          [
                                            _c(
                                              "el-button",
                                              {
                                                attrs: {
                                                  type: "text",
                                                  size: "small",
                                                  icon: "el-icon-delete",
                                                },
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.del(scope.row.id)
                                                  },
                                                },
                                              },
                                              [_vm._v("删除")]
                                            ),
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                ],
                1
              ),
              _c("vxe-pager", {
                attrs: {
                  background: "",
                  size: "small",
                  "current-page": _vm.tablePage.currentPage,
                  "page-size": _vm.tablePage.pageSize,
                  total: _vm.tablePage.total,
                  "page-sizes": [
                    10,
                    20,
                    100,
                    1000,
                    { label: "全量数据", value: 1000000 },
                  ],
                  layouts: [
                    "PrevPage",
                    "JumpNumber",
                    "NextPage",
                    "FullJump",
                    "Sizes",
                    "Total",
                  ],
                },
                on: { "page-change": _vm.currentChangeHandle },
              }),
            ],
            1
          ),
          _c("NotifyForm", {
            ref: "notifyForm",
            on: { refreshDataList: _vm.refreshList },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }